<template>
  <div id="locations">
    <wrld-container :breadcrumbs="this.breadcrumbs">
      <LocationTable
        :locations="locationList"
        :isFetching="locations.isFetching"
        @refresh-data="fetchLocations"
        :boxTitle="$tc('locations.location', 2)"
      />
    </wrld-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LocationTable from '@/components/locations/LocationTable'

export default {
  name: 'Locations',
  components: {
    LocationTable
  },
  data () {
    return {
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.tc('locations.location', 2), disabled: true }
      ]
    }
  },
  computed: {
    ...mapState(['route', 'locations']),
    locationList () {
      return Object.values(this.locations.data)
    }
  },
  created () {
    this.fetchLocations()
  },
  methods: {
    ...mapActions({
      fetchLocations: 'fetchLocations'
    })
  }
}
</script>
